import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { LoisirsAtna } from '../components/loisirs/LoisirsAtna';
import { ReadinessCard } from '../components/loisirs/ReadinessCard';
import { ForYou } from '../components/loisirs/ForYou';
import { MyActivities } from '../components/loisirs/MyActivities';
import { CardAccess } from '../components/loisirs/CardAccess';
import { BookingServices } from '../components/loisirs/BookingServices';
import { RegistrationFlow } from '../components/loisirs/RegistrationFlow';
import type { Activity } from '../data/loisirs';
export function MesLoisirs() {
  const [registering, setRegistering] = useState<Activity | null>(null);
  return <main className="bg-white" data-id="element-2068" data-mp="1fz8pl4638513">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2069" data-mp="1fy7cyv9fbah9">
        <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-2070" data-mp="2cjhgjkz7ay2v">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-2071" data-mp="27pmu49s7o503">
            Home
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2072" data-mp="2b26zfi7fjchb" />
          <span aria-current="page" data-id="element-2073" data-mp="2fye7phnat02f">My Recreation</span>
        </nav>

        <header className="mt-4" data-id="element-2074" data-mp="21at29h2yaorc">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-2075" data-mp="219rfifckodts">My Recreation</h1>
          <p className="mt-2 max-w-2xl text-[17px] text-slate-600" data-id="element-2076" data-mp="2671ealluq1ua">
            Find, book and get into Town programs, simply.
          </p>
        </header>

        <div className="mt-8" data-id="element-2077" data-mp="1x9hab4wltrfz">
          <LoisirsAtna onChip={() => undefined} data-id="element-2078" data-mp="1x9r4l4oomkrh" />
        </div>

        <div className="mt-8" data-id="element-2079" data-mp="1ic8g83fx29kk">
          <ReadinessCard data-id="element-2080" data-mp="1id00wj7z6mw2" />
        </div>

        <ForYou onRegister={setRegistering} data-id="element-2081" data-mp="1na05sqt39jll" />
        <MyActivities data-id="element-2082" data-mp="1nas2y62c3pdz" />
        <CardAccess data-id="element-2083" data-mp="1ncco552rdvz6" />
        <BookingServices data-id="element-2084" data-mp="3cpg398xnhgvn" />
      </div>

      <RegistrationFlow activity={registering} onClose={() => setRegistering(null)} data-id="element-2085" data-mp="3cqhrkf3ofzvb" />
    </main>;
}